<template>
  <div>
    <bottom-bar/>
    <div class="content">
      <div class="container-fluid mb-3" style="z-index: 10;" v-show="token">
        <div class="row no-gutters text-center mb-2">
          <div class="col pr-1">
            <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': selectedPedido === 1}" @click="togglePedido(1)">Em andamento</a>
          </div>
          <div class="col pr-1">
            <a href="javascript:" class="text-muted small py-2 menu-info" :class="{'active': selectedPedido === 2}" @click="togglePedido(2)">Finalizados</a>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
        <div v-show="!load">
          <div v-if="token">
            <div v-show="selectedPedido === 1">
              <pedido :pedidos="andamento" :empresa="empresa" @abrirPedido="abrirPedido" @atualizar="buscarPedidos"/>
            </div>
            <div v-show="selectedPedido === 2">
              <pedido :pedidos="finalizados" @abrirPedido="abrirPedido"/>
            </div>
          </div>
          <div class="text-center" v-show="(!andamento.length && selectedPedido === 1) || (!finalizados.length && selectedPedido === 2)" style="padding-top: 15vh">
            <icon name="pedido" class="text-primary" size="65"></icon>
            <div class="py-3" v-if="!token">
              <label class="d-block mb-3">Faça o login para acompanhar seus pedidos</label>
              <router-link :to="url + '/perfil'" class="btn btn-outline-primary">Fazer Login</router-link>
            </div>
            <div class="py-4" v-else>
              <div v-if="selectedPedido === 1">Nenhum pedido em andamento!</div>
              <div v-else>Nenhum pedido finalizado!</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-pedido ref="modalPedido" @atualizar="buscarPedidos"/>
  </div>
</template>

<script>
import BottomBar from '../components/BottomBar'
import Loading from '../components/Loading'
import Pedido from "../components/Pedido"
import Icon from "../components/Icon";
import ModalPedido from "../components/ModalPedido.vue";

export default {
  name: 'Pedidos',
  components: {ModalPedido, Icon, BottomBar, Loading, Pedido},
  data() {
    return {
      token: localStorage.getItem('token'),
      selectedPedido: 1,
      load: true,
      url: null,
      pedidos: [],
    }
  },

  methods: {
    togglePedido(sel) {
      if (this.selectedPedido === sel) {
        return;
      }

      this.selectedPedido = sel;
    },

    buscarPedidos(callback) {
      if (!this.token) {
        return;
      }

      this.load = true;
      const url = this.$helpers.base_url(this, this.empresa);

      this.$http.get(url + this.token + '/meus-pedidos')
        .then(response => {
          this.pedidos = response.data || [];
          localStorage.setItem('pedidos', this.andamento.length.toString());
          this.$emit('validarPedidos');

          this.load = false;

          if (callback) callback();

        }, res => {
          this.load = false;

          if (res.status === 401 && res.data.result !== '') {
            this.$swal(res.data.result + ' ' + res.data.msg).then(() => {
              this.$store.commit('logout');
              this.$router.push(this.url + '/perfil');
            });
          }
        });
    },

    abrirPedido(id_pedido, avaliar) {
      this.$refs.modalPedido.openModal(id_pedido, avaliar);
    }
  },

  mounted() {
    this.url = this.$helpers.getUrlApp(this.$route.params.id || '');

    if (this.token) {
      const id_pedido = this.$route.query.external_reference || null;
      const payment_id = this.$route.query.payment_id || null;

      if (id_pedido && payment_id) {
        this.$router.push(`${this.url}/pagamento/${id_pedido}?external_reference=${id_pedido}&payment_id=${payment_id}`);
        return;
      }

      this.buscarPedidos(() => {
        if (!this.andamento.length) {
          this.togglePedido(2);
        }

        const id_avaliar = this.$route.query.avaliar || null;

        if (id_avaliar && !isNaN(id_avaliar)) {
          this.abrirPedido(id_avaliar, true)
        }
      });

    } else {
      this.load = false;
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.modalPedido && this.$refs.modalPedido.opened) {
      this.$refs.modalPedido.closeModal();
      next(false);

    } else {
      next()
    }
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    },

    andamento() {
      return this.pedidos.filter(pedido => ![4, 5].includes(parseInt(pedido.status)));
    },

    finalizados() {
      return this.pedidos.filter(pedido => [4, 5].includes(parseInt(pedido.status)));
    },

    usuario() {
      return this.$store.state.dataUser
    },

    sem_senha() {
      return this.$store.state.dataUser.sem_senha
    }
  }
}
</script>

<style scoped>
</style>
